import { LogService } from 'library/ts/utilities/logger/LogService';
import { FreewheelConstants } from 'tag/ts/tag/model/FreewheelConstants';
export class FWUtilities {
    static _name = 'FWUtilities';
    static _instance = new FWUtilities();
    #logger;
    #nonEncodingValues = {
        [FreewheelConstants.getInstance().randomTag]: FreewheelConstants.getInstance().randomTag
    };
    constructor() {
        if (FWUtilities._instance) {
            throw new Error(FWUtilities._name + ' is a Singleton and can only be accessed through ' + FWUtilities._name + '.getInstance()');
        }
        FWUtilities._instance = this;
        this.#logger = LogService.create({ prefixes: ['SmartTag:', 'Tag:', FWUtilities._name] });
    }
    get utils() {
        return window?.SmartTag?.utilities;
    }
    static getInstance() {
        return FWUtilities._instance;
    }
    transformToUrlValue = (input) => {
        if (this.utils.Type.isNullOrUndefined(input) ||
            (!this.utils.Type.isString(input) && !this.utils.Type.isNumber(input) && !this.utils.Type.isBoolean(input)))
            return input;
        if (!this.utils.Type.isNullOrUndefined(this.#nonEncodingValues[input]))
            return this.#nonEncodingValues[input];
        return encodeURIComponent(input.toString());
    };
    createFWUrl = (fwModel, url = '') => {
        if (this.utils.Type.isNullOrUndefined(fwModel)) {
            this.#logger.error('createFWUrl', 'missing/invalid FreeWheelModel:', fwModel);
            return url;
        }
        const params = fwModel.adParameters;
        const utils = window.SmartTag.utilities;
        Object.keys(params)
            .filter((key) => !utils.Type.isEmpty(params[key]))
            .forEach((key) => {
            if (utils.Type.isArray(params[key]) && params[key].length > 0) {
                params[key]
                    .filter((item) => !utils.Type.isEmpty(item))
                    .forEach((item) => url = utils.URL.replaceParam(key, this.transformToUrlValue(item), url));
            }
            if (this.utils.Type.isString(params[key]) ||
                this.utils.Type.isNumber(params[key]) ||
                this.utils.Type.isBoolean(params[key])) {
                url = utils.URL.replaceParam(key, this.transformToUrlValue(params[key]), url);
            }
        });
        return url;
    };
    mergeFWParamsWithResourceConfig = (resource, model) => {
        if (this.utils.Type.isNullOrUndefined(resource)) {
            this.#logger.warn('mergeFWParamsWithResourceConfig', 'resource unset', 'resource:', resource);
            return resource;
        }
        if (this.utils.Type.isNullOrUndefined(model)) {
            this.#logger.error('mergeFWParamsWithResourceConfig', 'FreewheelModel unset', 'model:', model);
            return resource;
        }
        if (this.utils.Type.isNullOrUndefined(resource.ad?.ssai?.adParameters)) {
            resource.ad.ssai.adParameters = {};
        }
        const params = model.adParameters;
        const utils = window.SmartTag.utilities;
        Object.keys(params)
            .filter((key) => !utils.Type.isEmpty(params[key]))
            .forEach((key) => {
            if (key === 'bundle' || key === 'imafw_bundle') {
                const bundleValue = params[key]
                    .filter((item) => !utils.Type.isEmpty(item))
                    .map((item) => item)
                    .join(',');
                resource.ad.ssai.adParameters.cust_params = `bundle=${bundleValue}`;
            }
            else if (this.utils.Type.isString(params[key]) ||
                this.utils.Type.isNumber(params[key]) ||
                this.utils.Type.isBoolean(params[key])) {
                resource.ad.ssai.adParameters[key] = params[key];
            }
        });
        this.#logger.log('mergeFWParamsWithResourceConfig', 'returning resource:', resource);
        return resource;
    };
}
